import React from 'react';
import { Modal as BootstrapModal } from 'react-bootstrap';
import './Modal.scss';

interface ModalProps {
  show: boolean;
  onHide: () => void;
  title: React.ReactNode;
  children: React.ReactNode;
  size?: 'sm' | 'lg' | 'xl';
  footer?: React.ReactNode;
  className?: string;
  centered?: boolean;
}

const Modal: React.FC<ModalProps> = ({ show, onHide, title, children, size, footer, className, centered = true }) => {
  return (
    <BootstrapModal show={show} onHide={onHide} size={size} className={className} centered={centered}>
      <BootstrapModal.Header closeButton>
        <BootstrapModal.Title>{title}</BootstrapModal.Title>
      </BootstrapModal.Header>
      <BootstrapModal.Body>{children}</BootstrapModal.Body>
      {footer && <BootstrapModal.Footer>{footer}</BootstrapModal.Footer>}
    </BootstrapModal>
  );
};

export default Modal;
